const FinancialDimensionCategoryTypes = {
    Project: 1,
    Department: 2,
    Custom1: 3,
    Custom2: 4
};

Object.freeze(FinancialDimensionCategoryTypes);

export default FinancialDimensionCategoryTypes;